import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import ContactUsLeft from '../../components/ContactUsLeft';
import { t } from 'i18next';


const NewLaunchSec = (props) => {
    debugger
    const { data } = props
    return (
        <>
            <section className="details-slider-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 left-content">


                            <div className="property-view-section">
                                <h2 className="title">{t("about")} {data?.projectName}</h2>
                                <div className="payment-plan" dangerouslySetInnerHTML={{ __html: data?.description }} />
                            </div>
                            <div className="property-view-section">
                                <h2 className="title">{t("master_plan_features")}</h2>
                                <div className="payment-plan" dangerouslySetInnerHTML={{ __html: data?.featurePlan }} />

                            </div>
                            {/* <div className="property-view-section ul-list-box">
                                <h2 className="title">{t("smart_location")} {data?.projectName} {t("is")}:</h2>
                                <div className="payment-plan" dangerouslySetInnerHTML={{ __html: data?.smartLocation }} />
                            </div> */}

                        </div>
                        <div className="col-md-4 right-content">
                            <div className="contact-section inquiry-form-right ">
                                <ContactUsLeft></ContactUsLeft>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default NewLaunchSec